"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, ElementRef, Input, Optional, Renderer2, Self, } from '@angular/core';
import { MediaMonitor, ShowHideDirective as FlexLayoutShowHideDirective, } from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';
var LayoutShowDirective = (function (_super) {
    __extends(LayoutShowDirective, _super);
    function LayoutShowDirective(monitor, _layout, elRef, renderer) {
        var _this = _super.call(this, monitor, _layout, elRef, renderer) || this;
        _this._layout = _layout;
        _this.elRef = elRef;
        _this.renderer = renderer;
        return _this;
    }
    Object.defineProperty(LayoutShowDirective.prototype, "show", {
        set: function (val) {
            this._cacheInput('show', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showMobile", {
        set: function (val) {
            this._cacheInput('showMobile', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showTablet", {
        set: function (val) {
            this._cacheInput('showTablet', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showDesktopSmall", {
        set: function (val) {
            this._cacheInput('showDesktopSmall', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showDesktopLarge", {
        set: function (val) {
            this._cacheInput('showDesktopLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showDesktopXLarge", {
        set: function (val) {
            this._cacheInput('showDesktopXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutShowDirective.prototype, "showDesktopXXLarge", {
        set: function (val) {
            this._cacheInput('showDesktopXXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayoutShow'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "show", null);
    __decorate([
        Input('flLayoutShow.mobile'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showMobile", null);
    __decorate([
        Input('flLayoutShow.tablet'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showTablet", null);
    __decorate([
        Input('flLayoutShow.desktop-small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showDesktopSmall", null);
    __decorate([
        Input('flLayoutShow.desktop-large'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showDesktopLarge", null);
    __decorate([
        Input('flLayoutShow.desktop-xlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showDesktopXLarge", null);
    __decorate([
        Input('flLayoutShow.desktop-xxlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutShowDirective.prototype, "showDesktopXXLarge", null);
    LayoutShowDirective = __decorate([
        Directive({
            selector: "\n    [flLayoutShow],\n    [flLayoutShow.mobile],\n    [flLayoutShow.tablet],\n    [flLayoutShow.desktop-small],\n    [flLayoutShow.desktop-large],\n    [flLayoutShow.desktop-xlarge],\n    [flLayoutShow.desktop-xxlarge],\n  ",
        }),
        __param(1, Optional()),
        __param(1, Self()),
        __metadata("design:paramtypes", [MediaMonitor,
            LayoutDirective,
            ElementRef,
            Renderer2])
    ], LayoutShowDirective);
    return LayoutShowDirective;
}(FlexLayoutShowHideDirective));
export { LayoutShowDirective };



// WEBPACK FOOTER //
// layout-show.directive.js